import { FC, ReactNode } from 'react';
import { Button } from 'react-bootstrap';

interface SimpleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: string;
  height?: number;
  width?: number | string;
  size?: 'lg' | 'sm' | undefined;
  /** When false, label is not ellipsized (opt-in per button). Defaults to true. */
  truncate?: boolean;
  children: ReactNode;
  href?: string;
}

export const SimpleButton: FC<SimpleButtonProps> = ({
  variant,
  height,
  width,
  size,
  truncate = true,
  children,
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      {...rest}
      style={{ height: height ?? 52, ...(width !== undefined && { width }) }}
      className={`${rest.className ?? ''} ${!variant.includes('outline') ? 'btn-box-shadow text-uppercase border-0' : ''} text-uppercase ${truncate ? 'text-truncate' : 'text-nowrap flex-shrink-0'}`}
    >
      {children}
    </Button>
  );
};
